import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MilkFixedService from '~/api/services/milkFixedPrice'
import ProfileSettingsService from '~/api/services/profileSettings'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import TwoFaComp from '~/components/TwoFaComp'
import { useAuth } from '~/routes/components/AuthProvider'
import { handleErrors } from '~/utils/helpers'

interface Props {
  abortTradingSlotId: string
  handleClose: (fetchData?: boolean) => void
}

const AbortTradingSlot:React.FC<Props> = (props) => {
  const { abortTradingSlotId, handleClose } = props
  const { t } = useTranslation()
  const { systemData } = useAuth()
  const tfaAbortTradingSlot = systemData?.roleSettings?.tfaAbortTradingSlot === 1
  const tfaType = systemData?.logged?.tfaType

  const [isBusy, setIsBusy] = useState(false)
  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')

  useEffect(() => {
    if(abortTradingSlotId && tfaAbortTradingSlot) {
      handleSendCode()
    }
  }, [abortTradingSlotId])

  async function handleSendCode() {
    if (tfaType === 'email' || tfaType === 'sms') {
      setIsBusy(true)
      try {
        await ProfileSettingsService.sendCode()
        notify(t('Code sent'), 'success')
      } catch (error) {
        handleErrors(error)
      }
      setIsBusy(false)
    }
  }

  async function handleAbortTradingSlot(id: string, data?) {
    setIsBusy(true)
    try {
      await MilkFixedService.abortTradingSlot(id, data)
      notify(t('Trading slot aborted'), 'success')
      setTfaCode('')
      setCorrectTfaCode(false)
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(abortTradingSlotId)}
    textClose={t('No')}
    isLoading={isBusy}
    handleClose={() => {
      setTfaCode('')
      setCorrectTfaCode(false)
      handleClose()
    }}
    disableSubmit={tfaAbortTradingSlot ? !correctTfaCode : false}
    textSubmit={t('Yes')}
    handleSubmit={() => handleAbortTradingSlot(abortTradingSlotId, tfaAbortTradingSlot ? { code: tfaCode } : null)}
    textContent={<>
      <div>{t('Are you sure you want to abort this trading slot?')}</div>
      {tfaAbortTradingSlot && <TwoFaComp
        onChangeTfaCode={(code) => setTfaCode(code)}
        onChangeCorrectTfaCode={(correctTfaCode) => setCorrectTfaCode(correctTfaCode)}
      />}
    </>}
    textHeader={t('Abort trading slot')}
    type={'abort'}
    size={tfaAbortTradingSlot ? 'small' : 'tiny'}
  />
}
export default AbortTradingSlot